<div class="header-container">
  @if (loadingProgress) {
    <div class="progress-wrapper-map">
      <div class="progress-bar-map" [style.width.%]="loadingProgress"></div>
    </div>
  }
  <div class="header-filter">
    <div class="header-filter-left">
      <button
        class="filter-toggle-btn"
        [class.filter-toggle-btn-active]="activeFiltersCount > 0"
        (click)="onToggleFilters()"
        [matTooltip]="'sidenavFilters.title' | translate"
      >
        <mat-icon>tune</mat-icon>
        <span class="filter-toggle-label">{{
          "sidenavFilters.buttonLabel" | translate
        }}</span>
        @if (activeFiltersCount > 0) {
          <span class="filter-toggle-count">{{
            activeFiltersCount < 100 ? activeFiltersCount : "99+"
          }}</span>
        } @else {
          <mat-icon class="filter-toggle-arrow">chevron_right</mat-icon>
        }
      </button>

      <app-search-site-list
        (manageInput)="manageFilterSite($event)"
        [type]="'site'"
        [sites]="listSites"
        [inputData]="filterSite"
        [inputActive]="activeSite"
      ></app-search-site-list>

      <app-filter-button
        [type]="'checkbox'"
        [label]="'containerType'"
        [icon]="'container'"
        [checkedData]="filterContainers"
        (manageList)="manageContainers($event)"
      ></app-filter-button>

      <app-filter-button
        [type]="'colorStatus'"
        [label]="'colorStatus'"
        [icon]="'color-status'"
        [colorStatusData]="statusList"
        (manageList)="manageColorStatus($event)"
      ></app-filter-button>

      <app-filter-button
        [type]="'checkbox'"
        [label]="'lastAuthorizedSite'"
        [icon]="'last-site'"
        [checkedData]="filterLastSites"
        (manageList)="manageLAS($event)"
      ></app-filter-button>

      <app-filter-button
        [type]="'range'"
        [label]="'days'"
        [icon]="'calendar'"
        [rangeData]="filterStatusDays"
        (manageList)="manageStatusDays($event)"
      ></app-filter-button>
    </div>

    <div class="header-filter-right">
      <app-filter-button
        [iconOnly]="true"
        [type]="'checkbox'"
        [label]="'addIncident'"
        [icon]="'add-incident'"
        [isLoading]="isLoading"
        [isEmpty]="isEmptyIncidentDevice"
        (manageList)="addIncident($event)"
      ></app-filter-button>
    </div>
  </div>
</div>
